// extracted by mini-css-extract-plugin
export var layoutContainer = "_3m-0";
export var layoutContainerOpen = "_3m-3";
export var mainContent = "_3m-1";
export var panelLarge = "_3m-6";
export var panelMedium = "_3m-5";
export var panelSmall = "_3m-4";
export var slidePanel = "_3m-2";